import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util/strings'

const itemSpace = rem(21)

const item = theme => css`
  margin: 0 ${itemSpace};
  color: rgba(${theme.color.monochrome.white_rgba}, 0.8);
  transition: 0.2s color;
  padding: ${rem(4)};

  &.active,
  &:hover {
    color: ${theme.color.monochrome.white};
  }
`

const list = css`
  margin-left: -${itemSpace};
  margin-right: -${itemSpace};
`

export const styles = {
  item,
  list,
}
